module.exports = __webpack_public_path__ + "img/monitor_logo_dark.7b5eee08.svg";